export default "__VITE_ASSET__Bt_Wg27J__"